import ReactECharts from "echarts-for-react";

export default function TreemapChart({ data }) {
  const options = {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c}",
    },
    color: ["#01b8aa", "#6fd7cf", "#a4e6e0", "#ccf1ee", "#e8faf8"],
    series: [
      {
        type: "treemap",
        nodeClick: false,
        roam: false,
        breadcrumb: {
          show: false,
        },
        label: {
          show: true,
          color: "black",
          position: "insideTopLeft",
        },
        itemStyle: {
          borderColor: "black",
          borderWidth: 0.5,
        },
        data: data,
      },
    ],
  };

  return <ReactECharts option={options} style={{ height: 180 }} />;
}
